// biome-ignore-all lint/suspicious/noArrayIndexKey: TODO - address later
import { Folder } from "lucide-react";
import { Skeleton } from "@/components/ui/skeleton";
import { useCampaignsByIds } from "@/hooks/api/use-campaigns";

interface CampaignHierarchyProps {
  campaignId: string;
}

export function CampaignHierarchy({ campaignId }: CampaignHierarchyProps) {
  // Use the hook to fetch campaign data
  const { data: campaignsData, isLoading } = useCampaignsByIds(
    campaignId ? [campaignId] : undefined,
  );

  // Get hierarchy from the campaign data
  const campaignHierarchy = campaignsData?.results?.[0]?.campaign_ancestry_list;

  if (isLoading) {
    return (
      <div className="space-y-1 pl-1 py-1">
        <Skeleton className="h-6 w-full" />
        <Skeleton className="h-6 w-5/6" />
      </div>
    );
  }

  if (!campaignHierarchy || campaignHierarchy.length === 0) return null;

  // Reverse the hierarchy to show most specific (last) item first
  const reversedHierarchy = [...campaignHierarchy].reverse();

  return (
    <div className="space-y-1 pl-1 py-1">
      {reversedHierarchy.map((item, index) => (
        <div
          key={index}
          className="flex items-center"
          style={{ paddingLeft: `${index * 16}px` }}
        >
          <div className="flex items-center">
            <Folder size={16} className="mr-1.5 text-muted-foreground" />
            <span className="text-sm text-muted-foreground">{item}</span>
          </div>
          {index < reversedHierarchy.length - 1 && (
            <div
              className="ml-2 h-4 border-l border-dashed border-muted-foreground/50"
              style={{ marginLeft: "7px" }}
            ></div>
          )}
        </div>
      ))}
    </div>
  );
}
